import { selectKeyPath } from '@mdpp/od-belt';
import { useFormikContext } from 'formik';
import React from 'react';
import { SelectableButton } from './SelectableButton';
export function ODEnumInput(props) {
    var formikContext = useFormikContext();
    var name = props.name, keyPath = props.keyPath, textMap = props.textMap, style = props.style, styleSchema = props.styleSchema, enumSequence = props.enumSequence;
    var _a = formikContext || {}, setFieldValue = _a.setFieldValue, _b = _a.values, values = _b === void 0 ? {} : _b;
    var v = values;
    var currentEnumValue = selectKeyPath(keyPath)(v, '');
    // change case by style
    var minWidth = styleSchema.minWidth, minHeight = styleSchema.minHeight;
    return (React.createElement("div", { style: { display: 'flex' } }, enumSequence.map(function (enumValue) {
        var selected = enumValue === currentEnumValue;
        var text = textMap[enumValue] || '-';
        return (React.createElement(SelectableButton, { key: enumValue, selected: selected, minWidth: minWidth, minHeight: minHeight, onClick: function () { return setFieldValue(name, enumValue); } }, text));
    })));
}
//# sourceMappingURL=ODEnumInput.js.map